/**
 * Copyright (c) Qwoach LLC 2021. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 3.04.21
 *
 */
let {referrerIdToName} = require("./specialReferrers")
let Cookies = require('js-cookie')


exports.setSpecialReferrerIfNeeded = function(){
    let url = new URL(window.location.href)
    let referrerId = url.searchParams.get("specialId")
    let referrerName = referrerIdToName(referrerId)
    let referrerNameElem = $(".deal-from")
    let specialDealContainer = $(".special-deal-container")
    let priceContainer= $(".price-container")

    // console.log("referrerName = ", referrerName, ", referrerId = ", referrerId)
    // console.log("referrerNameElem = ", referrerNameElem)

    if(referrerName){
        specialDealContainer.show();
        referrerNameElem.text(" from " + referrerName)
        priceContainer.remove()
        Cookies.set("cpcd", "09A107BB", {expires: 30})
    } else {
        specialDealContainer.remove()
    }
}

exports.referrerRedirect = function (){
    let url = new URL(window.location.href)
    let referrerId = url.searchParams.get("specialId")
    let referrerName = referrerIdToName(referrerId)
    if(referrerName){
        let searchParams = window.location.search
        window.location.replace("special" + searchParams);
    }
}
